// Reads UTM params from the URL, stores them in a cookie (365-day expiry so they
// survive navigation), then populates any hidden form fields that have matching class names.
window.addEventListener("load", () => {
    const params = new URLSearchParams(window.location.search);
    const source = params.get("utm_source");
    const medium = params.get("utm_medium");
    const campaign = params.get("utm_campaign");

    if (source || medium || campaign) {
        const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `utm_params=${JSON.stringify({ source, medium, campaign })}; expires=${expires}; path=/`;
    }

    const cookie = document.cookie.split("; ").find(c => c.startsWith("utm_params="));
    if (!cookie) return;

    try {
        const { source, medium, campaign } = JSON.parse(cookie.split("=").slice(1).join("="));
        document.querySelectorAll(".utm_source").forEach(el => { el.value = source || ""; });
        document.querySelectorAll(".utm_medium").forEach(el => { el.value = medium || ""; });
        document.querySelectorAll(".utm_campaign").forEach(el => { el.value = campaign || ""; });
    } catch (_) {}
});
